document.addEventListener('DOMContentLoaded', function() {
  var popup = document.querySelector('.popup-slideout');
  var closeBtn = popup ? popup.querySelector('.popup-close-btn') : null;

  if (popup) {
    // Show the popup after a 3-second delay
    setTimeout(function() {
      popup.classList.add('show'); // Add class to slide the popup in
    }, 3000); // 3-second delay (adjust as needed)

    // Close the popup when the close button is clicked
    if (closeBtn) {
      closeBtn.addEventListener('click', function() {
        popup.classList.remove('show'); // Remove the class to hide the popup
      });
    }

    // Optionally, close the popup when clicking outside of it
    window.addEventListener('click', function(event) {
      if (event.target === popup) {
        popup.classList.remove('show'); // Close the popup if clicked outside
      }
    });
  }
});
